export class BaseMapData {
    isMapPremium() {
        if (this.isMapRestrictedByPremiumGameMode()) return true;
        if (this.isMapRestrictedByPremiumMap()) return true;
        return false;
    }
    isMapRestrictedByPremiumGameMode() {
        if (this.premiumExpansionAccess.length == 0) return false;
        return true;
    }
    isMapRestrictedByPremiumMap() {
        if (this.premiumMapAccess.length == 0) return false;
        return true;
    }
    getNewInstanceOfData() {
        /* eslint-disable @typescript-eslint/prefer-function-type */ const newInstance = new this.constructor();
        return newInstance;
    }
}
